export class WebsiteClauseModel {
  name: string;
  surname: string;
  email: string;
  city: string;
  telephoneNumber: string;
  singleProcessClause: string;
  multipleProcessesClause: string;
  personalDataClause: string;
  id: number;
  version: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/finish-ecv/website-clause.model.ts